import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "onboarding-guide__settings-setting-container" };
const _hoisted_2 = { class: "onboarding-guide__settings-setting-content v2-text--small text-v2-secondary" };
const _hoisted_3 = {
    key: 1,
    class: "onboarding-guide__settings-setting-completed-container"
};
const _hoisted_4 = { class: "v2-text--small-2 text-v2-secondary" };
import Collapsible from '@/components/collapsible/collapsible.vue';
import CheckMarkIcon from '@/components/icons/check-mark.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'setting',
    props: {
        title: {},
        isCompleted: { type: Boolean, default: false }
    },
    emits: ['expandChange'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        function expand(value) {
            emit('expandChange', value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!__props.isCompleted)
                    ? (_openBlock(), _createBlock(Collapsible, {
                        key: 0,
                        title: __props.title,
                        onExpand: expand
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _renderSlot(_ctx.$slots, "default")
                            ])
                        ]),
                        _: 3
                    }, 8, ["title"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(CheckMarkIcon, { class: "text-v2-success" }),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1)
                    ]))
            ]));
        };
    }
});
